/**
 * @flow
 * @relayHash 26bbcbeaea2b92d186d1833e1bb123c2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FolderWrapperWrapper_viewer$ref = any;
export type BulkActionsFolderRendererRendererQueryVariables = {|
  userIds: $ReadOnlyArray<?string>,
  selectedItemIds: $ReadOnlyArray<?string>,
  shouldFillInFolder: boolean,
|};
export type BulkActionsFolderRendererRendererQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: FolderWrapperWrapper_viewer$ref
  |}
|};
export type BulkActionsFolderRendererRendererQuery = {|
  variables: BulkActionsFolderRendererRendererQueryVariables,
  response: BulkActionsFolderRendererRendererQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "selectedItemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shouldFillInFolder",
    "type": "Boolean!",
    "defaultValue": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BulkActionsFolderRendererRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FolderWrapperWrapper_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BulkActionsFolderRendererRendererQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "BulkActionsFolderRendererRendererQuery",
    "id": "app-buyer-misc/209.0.0-2019-03-26T14:04:46.491Z/BulkActionsFolderRendererRendererQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '00acb5a0c83bb2999e5f24a4a0705118';
module.exports = node;
